import type { AppointmentForm } from "@/lib/hooks/useAppointment";

type QuoteReference = Pick<AppointmentForm, "requestId" | "quotePublicId">;

/**
 * Quote links always create a new appointment so the create endpoint can
 * validate and atomically consume the exact quote revision. Treat either
 * marker as quote-backed to fail closed if a rolling client is malformed.
 */
export function isQuoteBackedBooking(reference: QuoteReference): boolean {
  return Boolean(reference.requestId || reference.quotePublicId);
}

/**
 * Customer DEPOSIT tags can raise an ordinary booking to full prepayment, but
 * an exact quote already promises immutable payment terms to the customer.
 */
export function shouldApplyCustomerDepositGate(
  reference: QuoteReference,
  customerDepositRequired: boolean,
): boolean {
  return customerDepositRequired && !isQuoteBackedBooking(reference);
}

export function shouldOfferExistingAppointmentReschedule(
  reference: QuoteReference,
  hasUpcomingAppointments: boolean,
): boolean {
  return !isQuoteBackedBooking(reference) && hasUpcomingAppointments;
}
